const ts = {
  ERROR_GENERAL_1: {
    description: 'General Error 1',
    primaryValue: 'An error occurred',
    stringKey: 'ERROR_GENERAL_1',
  },
  TOASTR_CHANGES_SAVED: {
    description: 'Changes Saved',
    primaryValue: 'Changes Saved',
    stringKey: 'TOASTR_CHANGES_SAVED',
  },
  COMP_INVALID_MESSAGE: {
    description: 'Comp Invalid Message',
    primaryValue: 'Comp Invalid Message',
    stringKey: 'COMP_INVALID_MESSAGE',
  },
  PASS_MODAL_COMP_AMOUNT_HELP_TEXT: {
    description: 'Comp Amount Help Text',
    primaryValue: 'The amount of the comp',
    stringKey: 'PASS_MODAL_COMP_AMOUNT_HELP_TEXT',
  },
  DDL_STORE_SELECT: {
    description: 'Select Store',
    primaryValue: 'Select Store',
    stringKey: 'DDL_STORE_SELECT',
  },
  SAVING_TEXT: {
    description: 'Saving Text',
    primaryValue: 'Saving...',
    stringKey: 'SAVING_TEXT',
  },
  VALIDATION_REQUIRED_FIELD: {
    description: 'Required Field',
    primaryValue: 'Required Field',
    stringKey: 'VALIDATION_REQUIRED_FIELD',
  },
  PASS_MODAL_GUEST_INFO_HEADING: {
    description: 'Guest Information',
    primaryValue: 'Guest-Info',
    stringKey: 'PASS_MODAL_GUEST_INFO_HEADING',
  },
  PLACEHOLDER_COMPANY_NAME: {
    description: 'Company Name',
    primaryValue: 'Company Name',
    stringKey: 'PLACEHOLDER_COMPANY_NAME',
  },
  PASS_MODAL_STORE_HEADING: {
    description: 'Store Information',
    primaryValue: 'Store Info',
    stringKey: 'PASS_MODAL_STORE_HEADING',
  },
  PASS_MODAL_DATE_HEADING: {
    description: 'Date',
    primaryValue: 'Date',
    stringKey: 'PASS_MODAL_DATE_HEADING',
  },
  PASS_MODAL_COMP_AMOUNT_HEADING: {
    description: 'Comp Amount',
    primaryValue: 'Comp Amount',
    stringKey: 'PASS_MODAL_COMP_AMOUNT_HEADING',
  },
  PLACEHOLDER_DOLLAR_SIGN: {
    description: 'Dollar Sign',
    primaryValue: '$',
    stringKey: 'PLACEHOLDER_DOLLAR_SIGN',
  },
  PASS_MODAL_COMP_NUMBER_HEADING: {
    description: 'Comp Number',
    primaryValue: 'Comp Number',
    stringKey: 'PASS_MODAL_COMP_NUMBER_HEADING',
  },
  PLACEHOLDER_COMP_NUMBER: {
    description: 'Comp Number',
    primaryValue: 'Comp Number',
    stringKey: 'PLACEHOLDER_COMP_NUMBER',
  },
  PLACEHOLDER_LAST_NAME: {
    description: 'Last Name',
    primaryValue: 'Last Name',
    stringKey: 'PLACEHOLDER_LAST_NAME',
  },
  PLACEHOLDER_FIRST_NAME: {
    description: 'First Name',
    primaryValue: 'First Name',
    stringKey: 'PLACEHOLDER_FIRST_NAME',
  },
  PASS_MODAL_REGISTER: {
    description: 'Register',
    primaryValue: 'Register',
    stringKey: 'PASS_MODAL_REGISTER',
  },
  TOASTR_PASS_ADDED: {
    description: 'Pass Added',
    primaryValue: '{{passType}} pass added',
    stringKey: 'TOASTR_PASS_ADDED',
  },
  TOASTR_PASS_ERROR: {
    description: 'Pass Error',
    primaryValue: 'There was an error adding your pass.',
    stringKey: 'TOASTR_PASS_ERROR',
  },
  PASS_MODAL_UPDATE: {
    description: 'Update',
    primaryValue: 'Update',
    stringKey: 'PASS_MODAL_UPDATE',
  },
};

export default ts;
